import { get } from "../../utils/object-helpers";

$ {
    const title = get(input, "title", {});
    const sections = get(input, "sections", []);
}

<section class="str-business-details">
    <str-title ...title />
    <div class="str-business-details__seller-info">
        <for|section| of=sections>
            $ {
                const title = get(section, "title", {});
                const action = get(section, "action", {});
            }
            <str-textual-display ...title action=action/>
        </for>
    </div>
</section>
